"use client";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { useState } from "react";
import {
  ArrowRightCircleIcon,
  ArrowLeftCircleIcon,
} from "@heroicons/react/20/solid";
import {
  GROUP_LINKS,
  SOCIAL_LIST,
  ENQUIRIES_LIST,
  type GroupLinksProps,
} from "~/content/contact";

const ContactSlider = ({ bgColor }: GroupLinksProps) => {
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    // loop: true,
    mode: "free-snap",
    slides: { perView: 1, spacing: 15 },

    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
  });

  const [loaded, setLoaded] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    <>
      <div
        className={`flex h-full items-center justify-center gap-4 lg:hidden`}
      >
        {loaded && instanceRef.current && (
          <>
            <ArrowLeftCircleIcon
              onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) =>
                instanceRef.current?.prev() || e.stopPropagation()
              }
              className={`size-9 cursor-pointer xs:size-7 ${
                currentSlide === 0
                  ? "pointer-events-none fill-orange/0"
                  : "fill-orange"
              } `}
            />
          </>
        )}

        <div ref={sliderRef} className="keen-slider h-full max-w-64">
          <div className="keen-slider__slide number-slide1">
            <GROUP_LINKS
              items={ENQUIRIES_LIST}
              title="Enquiries"
              borderColour="border-orange"
              width="max-w-64"
              bgColor={bgColor}
            />
          </div>
          <div className="keen-slider__slide number-slide2">
            <GROUP_LINKS
              items={SOCIAL_LIST}
              title="Socials"
              borderColour="border-green"
              width="max-w-64"
              newTab
              bgColor={bgColor}
            />
          </div>
        </div>
        {loaded && instanceRef.current && (
          <>
            <ArrowRightCircleIcon
              onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) =>
                instanceRef.current?.next() || e.stopPropagation()
              }
              className={`size-9 cursor-pointer xs:size-7 ${
                currentSlide ===
                instanceRef.current.track.details.slides.length - 1
                  ? "pointer-events-none fill-green/0"
                  : "fill-green"
              }`}
            />
          </>
        )}
      </div>
    </>
  );
};

export default ContactSlider;
